export default "__VITE_ASSET__tk0K_3jJ__"